import React from "react";
import AnimatedOutlet from "../../components/AnimatedOutlet";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";

export default function RootLayout() {
  return (
    <div className="page">
      <Navbar />
      <AnimatedOutlet />
      <Footer />
    </div>
  );
}
